import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmitterService {

  record: any = {};
  objectEmitter = new EventEmitter();
  objectSubscription: Subscription;

  /**
   * 
   * @param formAction  String action name to emit
   * @param data        Object data that you need to transfer
   */
   setValue(formAction: string, data?: any) {
    this.record.formAction = formAction || "";
    this.record.data = data || null;
    // console.log("record service", this.record);
    
    this.objectEmitter.emit(this.record);
  }

  getValue() {
    return this.record;
  }
}
